import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow } from '../../ui';
import React from 'react';
import {
  formatDateinStyled
} from '../../../constants/constant';

const BuildKotDisplayData = ({ prodName, kots }) => {
    return (
        <>
            {(Array.isArray(kots) && kots.length > 0) &&
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" className="rate_card">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Kot No.</TableCell>
                                <TableCell align="center">Name</TableCell>
                                <TableCell align="center">Quan.</TableCell>
                                <TableCell align="center">On</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {kots.map((singleKot) => {
                                return (
                                    <TableRow
                                        className="rate_card--row"
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center">{singleKot.count}</TableCell>
                                        <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{prodName}</p></TableCell>
                                        <TableCell align="center">{(singleKot.positive ? "+" : "-") + singleKot.quantity}</TableCell>
                                        <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{formatDateinStyled(singleKot.createdOn)}</p></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </>
    );
}

export default BuildKotDisplayData;